import React, { Component } from 'react'
import classNames from 'classnames'
import { InView } from 'react-intersection-observer';

import Media from '../pageContent/Media'

class Event extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isVisible: false
        }

        this.onChange = this.onChange.bind(this)
    }

    onChange(inView) {

        this.setState({
            isVisible: inView
        })

    }

    render() {

        const { fields, offset } = this.props
        const { date, title, description, url, media } = fields



        const d = new Date(date)

        var monthNames = [
            "January", "February", "March",
            "April", "May", "June", "July",
            "August", "September", "October",
            "November", "December"
        ];

        const formattedDate = `${monthNames[d.getMonth()]} ${d.getFullYear()}`

        const eventStyle = {
            opacity: this.state.isVisible ? 1 : 0

        }

        const unitClass = classNames({
            unit: true,
            'half': true,
            offset: offset
        });

        return (

            <InView onChange={this.onChange} triggerOnce={false}>
                {({ ref }) => (
                    <div ref={ref} className="grid">

                        {offset &&
                            <div className="unit half hide-on-mobiles"></div>
                        }

                        <div className={unitClass}>

                            <div className="event" style={eventStyle}>

                                <div className="rect"></div>
                                <div className="marker"></div>
                                
                                {media && 
                                    <Media data={media} />
                                 }
                             


                                <div className="text">

                                    <div className="mb10">
                                        <div className="text-muted">{formattedDate}</div>
                                    </div>
                                    <h2>{title}</h2>
                                    <p>
                                        {description}
                                    </p>
                                    <a href={url} className="poke" target="_blank" rel="noopener noreferrer">Visit {title}</a>

                                </div>

                            </div>
                        </div>

                    </div>
                )}
            </InView>

        );
    }
}


export default Event;
